export default __webpack_public_path__ + "static/media/trapezoid_left.7285eec3.png";